export function isPositiveNumericStringValue(value?: Nullable<string>) {
  // ignore nullish value
  if (!value) return true

  // check first character for `-` sign
  return value[0] !== '-'
}
